import { render, staticRenderFns } from "./WorkflowInvocationStepHeader.vue?vue&type=template&id=256ea402"
import script from "./WorkflowInvocationStepHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./WorkflowInvocationStepHeader.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports